















































import {
  defineComponent,
  ref,
  computed,
  onMounted,
  onBeforeUnmount,
} from '@vue/composition-api';
import { queryCreditApplyStatus } from '@/api/rights/shop-mall';
import { ubtSendError } from '@/shared/utils/ubt';
import NavBar from '@/components/nav-bar-coffee/index.vue';
import {
  AbExperimentKey,
  getAbResultByKey,
  isSkipCountdownGroup,
} from '@/shared/ab-experiment/shopMallExperiments';
import { Button, Toast } from '@hb/coffee';
import { openThirdPage } from '@/api/native/utils';
import { ubtSetupModuleExpose, ubtSetupPageButton } from '@/shared/utils/ubt/ubt-setup';
import { shopMallAgreementResultExpose, shopMallAgreementResultClick } from './tianqi';

export default defineComponent({
  name: 'FqMallPreApplySuccess',
  components: {
    NavBar,
    Button,
  },
  props: {
    creditTaskId: {
      type: String,
      default: '',
    },
    from: {
      type: String,
      default: '',
    },
    source: {
      type: String,
      default: '',
    },
    skipCountdown: {
      type: String,
      default: '0',
    },
  },
  setup(
    props: {
      creditTaskId: string,
      from: string,
      source: string,
      skipCountdown: string,
    },
    context: any,
  ) {
    const applyAmount = ref('');
    const jumpUrl = ref('');
    const countdown = ref(props.skipCountdown === '1' ? 0 : 2);
    const pollingProductId = ref('');

    let countdownTimer: ReturnType<typeof setInterval> | null = null;

    /**
     * 格式化金额：三位一个逗号
     */
    const formattedAmount = computed(() => {
      if (!applyAmount.value) {
        return '';
      }
      const num = Number(applyAmount.value);
      if (Number.isNaN(num)) {
        return applyAmount.value;
      }
      return String(num).replace(/(\d)(?=(?:\d{3})+($|\.))/g, '$1,');
    });

    /**
     * 清除倒计时
     */
    const clearCountdownTimer = () => {
      if (countdownTimer) {
        clearInterval(countdownTimer);
        countdownTimer = null;
      }
    };

    /**
     * 跳转到分期商城
     */
    const jumpToShopMall = () => {
      if (jumpUrl.value) {
        clearCountdownTimer();
        openThirdPage(jumpUrl.value);
      }
    };

    /**
     * 开始倒计时
     */
    const startCountdown = () => {
      clearCountdownTimer();
      countdown.value = 3;
      Toast(`授信成功，${countdown.value}s后自动跳转`);

      countdownTimer = setInterval(() => {
        countdown.value -= 1;
        if (countdown.value <= 0) {
          clearCountdownTimer();
          jumpToShopMall();
        } else {
          // 只在倒计时大于0时显示 Toast
          Toast(`授信成功，${countdown.value}s后自动跳转`);
        }
      }, 1000);
    };

    /**
     * 加载授信结果。若来自 unit-waiting-page 会带 query.skipCountdown，直接据此决策；否则在请求结果前拉取 AB。
     */
    const loadCreditResult = async () => {
      try {
        // 来自 unit-waiting-page 时已带 skipCountdown，直接使用，不再请求 AB
        const abSkipCountdown = props.skipCountdown === '1';
        const { creditTaskId } = props;
        const result = await queryCreditApplyStatus({
          creditTaskId,
          from: props.from,
        });

        if (result) {
          applyAmount.value = result.creditAmount || '';
          jumpUrl.value = result.jumpUrl || '';

          // 获取 productIdList 并用逗号拼接
          const { productIdList = [] } = result;
          if (productIdList && productIdList.length > 0) {
            pollingProductId.value = productIdList.join(',');
          }

          // 使用本次加载前拉取的 AB 结果：实验组不倒计时，对照组 3s 倒计时
          if (jumpUrl.value) {
            if (!abSkipCountdown) {
              startCountdown();
            } else {
              jumpToShopMall();
            }
          }
        }
      } catch (error) {
        ubtSendError('pre_apply_success_load_credit_result_error');
      }
    };

    const handleContentButtonClick = async () => {
      ubtSetupPageButton(shopMallAgreementResultClick, {
        buttonName: '去使用',
        from: props.from,
        source: props.source,
      });

      // 清除倒计时
      clearCountdownTimer();

      if (!jumpUrl.value) {
        await loadCreditResult();
      }

      // 跳转到分期商城页面
      jumpToShopMall();
    };

    onMounted(async () => {
      await loadCreditResult();
      ubtSetupModuleExpose(shopMallAgreementResultExpose, {
        /** 投放来源 */
        from: props.from,
        /** 是否二次进入分期商城协议页 */
        source: props.source,
        pollingProductId: pollingProductId.value,
      });
    });

    // 组件销毁时清除定时器
    onBeforeUnmount(() => {
      clearCountdownTimer();
    });

    return {
      applyAmount,
      formattedAmount,
      countdown,
      handleContentButtonClick,
    };
  },
});
